import React, { useEffect, useRef } from "react";
import { Fade } from "react-awesome-reveal";
import "../assets/css/style.css";
import vrImage from "../assets/image/VR-img.jpg";

const VirtualTour = () => {
  const imageRef = useRef(null);

  // 3D Parallax hover effect
  useEffect(() => {
    const image = imageRef.current;
    const handleMouseMove = (e) => {
      const rect = image.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      image.style.transform = `rotateY(${x * 0.05}deg) rotateX(${-y * 0.05}deg) scale(1.05)`;
    };
    const reset = () => {
      image.style.transform = "rotateY(0deg) rotateX(0deg) scale(1)";
    };
    image.addEventListener("mousemove", handleMouseMove);
    image.addEventListener("mouseleave", reset);
    return () => {
      image.removeEventListener("mousemove", handleMouseMove);
      image.removeEventListener("mouseleave", reset);
    };
  }, []);

  const openVR = () => {
    window.open(
      "https://www.coohom.com/pub/tool/panorama/viewer?obsPicId=3FOKOUPPNM6D&locale=en_US",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="container-xxl py-6">
      <div className="container">
        {/* Single VR Section wrapping both text and image */}
        <Fade triggerOnce>
          <div className="vr-rare-section">
          {/* Neon grid background */}
          <div className="vr-grid"></div>

          {/* Floating holographic particles */}
          <div className="vr-particles">
            {Array.from({ length: 20 }).map((_, i) => (
              <div key={i} className="vr-particle"></div>
            ))}
          </div>

          {/* Main content flex container */}
          <div className="vr-rare-content">
            {/* Left - Text */}
            <div className="vr-text-container">
              <h2 className="vr-animate-line">
                Step into <span className="vr-highlight">Virtual Reality</span>
              </h2>
              <p className="vr-animate-line-delay">
                Experience immersive VR showrooms, interactive 360° ads, and futuristic experiences
                that captivate and inspire your audience.
              </p>
              <button className="vr-btn" onClick={openVR}>
                Explore in VR
              </button>
            </div>

            {/* Right - Image */}
            <div className="vr-image-container">
              <img ref={imageRef} src={vrImage} alt="Person wearing VR headset" />
              <div className="vr-image-glow"></div>
            </div>
          </div>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default VirtualTour;
